import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Copy from 'Src/components/Copy';
import { Modal } from 'Src/feature/modal/Modal';
import { ModalAction } from 'Src/feature/modal/ModalAction';
import { ModalActions } from 'Src/feature/modal/ModalActions';
import { ModalContent } from 'Src/feature/modal/ModalContent';
import { ModalHeader } from 'Src/feature/modal/ModalHeader';
import { ModalTitle } from 'Src/feature/modal/ModalTitle';
import { useCheckPagePayment } from 'Src/feature/payment/useCheckPagePayment';
import { usePaymentFlow } from 'Src/feature/payment/usePaymentFlow';
import { useToastWhen } from 'Src/feature/toasts/useToastWhen';

const sectionId = 'GiftCardBalanceApplyModal';

interface GiftCardBalanceApplyModalProps {
  control: ReturnType<typeof useCheckPagePayment>['modal']['giftCardBalanceApply']
}
const GiftCardBalanceApplyModalContent: FC<GiftCardBalanceApplyModalProps> = ({ control }) => {
  const { t } = useTranslation();

  const paymentFlow = usePaymentFlow();
  const balance = paymentFlow.gc.balance?.balance ?? 0;

  useToastWhen({
    id: `${sectionId}-gc-zero-balance`,
    type: 'alert',
    props: {
      message: t('giftCard.errors.zeroBalance'),
      severity: 'error',
    },
  }, () => !balance);

  return (
    <>
      <ModalHeader>
        <ModalTitle copy={t('giftCard.labels.balance')} />
      </ModalHeader>
      <ModalContent flex={{ alignItems: 'center', justifyContent: 'center' }}>
        <Copy variant="h4" value={t('labels.util.currency', { value: balance })} />
      </ModalContent>
      <ModalActions>
        <ModalAction
          color="secondary"
          label={t('labels.cancel')}
          onClick={control.close}
        />
        <ModalAction
          color="primary"
          label={t('giftCard.labels.applyToCheck')}
          onClick={control.onApplyClick}
          disabled={!balance}
        />
      </ModalActions>
    </>
  );
};


// eslint-disable-next-line react/no-multi-comp
const GiftCardBalanceApplyModal: FC<GiftCardBalanceApplyModalProps> = ({ control }) => (
  <Modal
    data-testid={sectionId}
    open={control.isOpen}
    onBackDropClick={control.close}
  >
    <GiftCardBalanceApplyModalContent control={control} />
  </Modal>
);

export { GiftCardBalanceApplyModal };
